import { $fetch, $post, $put, $delete } from '@/services/axios';

export function validate(data) {
  return $post(`company/cohort/validate`, data);
}

export function add(data) {
  return $put(`company/cohort`, data);
}

export function fetch(data) {
  return $fetch(`company/${data.campaignId}/cohorts`);
}

export function remove(data) {
  return $delete(`company/cohort/${data.id}/${data.version}`);
}
